import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';

import {
  academyProjectDetailsModalStateSelector,
  setAcademyProjectDetailsModalState,
} from 'features/classCreation';
import AcademyProjectDetailsModalContent from '../AcademyProjectDetailsModalContent';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';

export default function AcademyProjectDetailsModal({ academyTopic }) {
  const dispatch = useAppDispatch();
  const isModalOpen = useAppSelector(academyProjectDetailsModalStateSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setAcademyProjectDetailsModalState(false));
  }, [dispatch]);

  return (
    <Modal
      withoutHeader
      unMountOnClose
      isOpen={isModalOpen}
      onClose={handleModalClose}
      size="extraLarge"
      className="p-m"
    >
      <AcademyProjectDetailsModalContent academyTopic={academyTopic} />
    </Modal>
  );
}
